import axios from "axios";
import { apiKey } from "./config";

let language;

const defaultLang = localStorage.getItem("rms-lang") || "text_en";

async function fetchLanguage() {
  try {
    const res = await axios.get(`${apiKey}/api/rms/customer/language`);

    language = {
      text_en: JSON.parse(res.data[0].text_en),
      text_ar: JSON.parse(res.data[0].text_ar),
    };
  } catch (err) {
    console.log(err);
  }
}

fetchLanguage();

export function languageHelper(key, lang = defaultLang) {
  if (!language) return key;
  return language[lang]?.[key] || key;
}

const extractPrinterData = (data, printingType) => {
  const printers = {};

  if (printingType === "Category Wise") {
    data?.order_details?.forEach((detail) => {
      const printerName = detail.food_menu.category.add_port;

      if (!printers[printerName]) {
        printers[printerName] = [];
      }
      printers[printerName].push(detail);
    });
  } else {
    data.order_details.forEach((detail) => {
      const printerName = detail.food_menu.add_port_by_product;
      if (!printers[printerName]) {
        printers[printerName] = [];
      }

      printers[printerName].push(detail);
    });
  }
  return printers;
};

function formatDateToInputValue(date) {
  const pad = (n) => n.toString().padStart(2, "0");
  const year = date.getFullYear();
  const month = pad(date.getMonth() + 1);
  const day = pad(date.getDate());
  const hours = pad(date.getHours());
  const minutes = pad(date.getMinutes());
  return `${year}-${month}-${day}T${hours}:${minutes}`;
}

function darkenHexColor(hex, amount = 20) {
  // Remove "#" if present
  hex = hex.replace(/^#/, "");

  // Convert 3-digit hex to 6-digit
  if (hex.length === 3) {
    hex = hex
      .split("")
      .map((x) => x + x)
      .join("");
  }

  // Convert to RGB
  let r = parseInt(hex.substring(0, 2), 16);
  let g = parseInt(hex.substring(2, 4), 16);
  let b = parseInt(hex.substring(4, 6), 16);

  // Darken each channel
  r = Math.max(0, r - amount);
  g = Math.max(0, g - amount);
  b = Math.max(0, b - amount);

  // Convert back to hex
  return `#${[r, g, b].map((x) => x.toString(16).padStart(2, "0")).join("")}`;
}

const generateReferenceNumber = () => {
  // Generate a random number between 100000000 and 999999999
  return Math.floor(100000000 + Math.random() * 900000000).toString();
};

export {
  extractPrinterData,
  formatDateToInputValue,
  darkenHexColor,
  generateReferenceNumber,
};
